// extracted by mini-css-extract-plugin
export default {"BaseNav":"BaseNav3lt8nfGCgwQl","BaseNav_aside":"BaseNav_aside1buYbOgtXyyq"};